module.exports = __webpack_public_path__ + "img/prisma.9191e5ae.png";